import React from 'react';
import Button from '../../components/Button';
import {useAnalytics} from '../../hooks';

const AffiliateSidebar = (props) => {
  const {tracker} = useAnalytics();

  const {author = {}} = props;
  const {
    name,
    image,
    title,
    affiliateURL,
    affiliateName,
  } = author;

  const handleTrack = () => {
    tracker.questionClickAffiliate();
  };

  return (
    <div className="flex flex-col w-64">
      <div className="AffiliateSidebar__header flex flex-row mb-4">
        <img alt={name} className="rounded-full h-10 w-10 mr-4" src={image} />
        <div className="flex flex-col">
          <p className="font-medium">
            {name}
            &nbsp;
            <span style={{fontSize: '0.65rem', backgroundColor: '#D9EFEE', color: '#39ADA6'}} className="font-medium ml-1 p-1 uppercase rounded tracking-wide">
              expert
            </span>
          </p>
          <p className="text-gray-700">{title}</p>
        </div>
      </div>
      <p className="mb-4 text-base text-gray-700 font-medium">
        This video is an exclusive preview of&nbsp;
        <a target="_blank" rel="noopener noreferrer" href={affiliateURL} onClick={handleTrack}>
          <span style={{color: '#5524e0'}}>
            {affiliateName}
          </span>
        </a>
      </p>
      <Button
        target="_blank"
        href={affiliateURL}
        onClick={handleTrack}
      >
        Watch More
      </Button>
    </div>
  );
};

export default AffiliateSidebar;
